const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex h-dvh w-full items-center justify-center bg-[#F5F5F5]">
      <video
        autoPlay
        muted
        playsInline
        loop
        className="h-full w-full object-contain"
      >
        <source src="/Loading-screen-animation.mp4" type="video/mp4" />
      </video>
    </div>
  );
};

export default LoadingScreen;